<template>
    <ls-modal :options="modals.whyLawnTreatment" @onModalClose="closeModal('whyLawnTreatment')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green">Why is Lawn Treatment Important?</h3>
        </div>

        <div class="grid">
            <div class="grid__col-12">
                <p class="ls-align--center">
                    <img :src="ltrsIcon" width="137" height="86" />
                </p>
                <br />
                <ul>
                    <li>Lawn treatment strengthens grass and its root system</li>
                    <li>
                        Make your lawn less vulnerable to weeds, disease and more resistant to pests
                    </li>
                    <li>Lawn treatment will improve grass growth and protect its soil</li>
                </ul>
                <br />
                <br />
            </div>
        </div>

        <div class="grid">
            <div class="grid__col-12">
                <p class="ls-align--center">
                    <button
                        slot="button"
                        class="ls-button ls-button--yellow"
                        type="button"
                        @click.prevent="toggleLawnTreatment()"
                    >
                        Add Lawn Treatment
                    </button>
                </p>
                <p class="ls-align--center">
                    <button
                        slot="button"
                        class="ls-button ls-button--white"
                        type="button"
                        @click="closeModal('whyLawnTreatment')"
                    >
                        Return to Schedule
                    </button>
                </p>
            </div>
        </div>
        <lsFAQ :data="accordionData" />
    </ls-modal>
</template>

<script>
import LtrsIcon from '@/assets/ltrs-icon.png';
import { mapActions, mapGetters, mapState } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';
import lsFAQ from '@/components/LsFAQ/LsFAQ.vue';

export default {
    components: {
        lsModal,
        lsFAQ,
    },
    data() {
        return {
            ltrsIcon: LtrsIcon,
            accordionData: [
                {
                    title: 'When should I start treatment?',
                    content: `For best results, we currently offer and recommend a year-round treatment for comprehensive fertilization and weed control. This is a reoccurring service, every 4-6 weeks. Our pro will customize your service to your lawn needs on each treatment.`,
                },
                {
                    title: 'When is the first service?',
                    content: `Your initial lawn treatment service will occur within a 3-week window from today's date. Each additional service will be scheduled about 4-6 weeks apart. Check in-app for the next service.`,
                },
                {
                    title: 'Can I cancel anytime?',
                    content: `You can cancel anytime. You are never charged until after the service is completed. However, we recommend at least 8 treatments to see the best results.`,
                },
            ],
        };
    },
    computed: {
        ...mapState(['cart', 'modals']),
        ...mapGetters({
            lawnTreatment: types.ORDER__GET_PRICED_LAWNTREATMENT,
            lawnTreatmentIsInCart: types.CART__GET_PRICED_LAWNTREATMENT_IS_IN_CART,
        }),
    },
    methods: {
        ...mapActions({
            addServiceToCart: types.CART__ADD_SERVICE_TO_CART,
            closeModal: types.MODAL__CLOSE_MODAL,
        }),

        toggleLawnTreatment() {
            if (!this.lawnTreatmentIsInCart) {
                this.addServiceToCart(this.lawnTreatment);
            }
            this.closeModal('whyLawnTreatment');
        },
    },
};
</script>

<style lang="scss" scoped>
h1 {
    margin-bottom: rem(-4);
}

h4 {
    margin-top: rem(0);
    margin-bottom: 3px;
    font-size: rem(-1);
}

p {
    font-size: rem(-1);
    margin-top: 0;
}

.faq--wrapper {
    margin-top: 40px;
    padding: 16px;
}
</style>
